// combatpro/panels/monsters/studio/useMonsterStudioPreview.js
//
// Combat PRO - Monster Studio preview runtime (Stage 59: Preview Runtime).
//
// The preview runtime, expressed as a React hook. It owns exactly three things -
// the active preview mode, the open/closed state of the preview modal, and the
// print action - and nothing else. It is a faithful migration of the legacy preview
// controller (battletracker.html: viStudioPreview 11372 opens at mode '5e';
// viStudioPreviewSet 11379 switches mode; viStudioPreviewPrint 11380 prints;
// viStudioPreviewClose 11387 closes).
//
// It does NOT hold a copy of the monster. The preview always renders from the live
// editor model, which the component receives directly, so every edit updates the
// preview with no manual refresh and no duplicated state. This hook reads nothing
// from the model itself; it only carries UI state and, for printing, hands the
// current model to the pure print-document builder.
//
// Read-only: no editing, no save, no persistence, no backend, no model mutation.
// The only side effect is opening a separate browser window for printing (the
// legacy behaviour) - it never manipulates the application DOM. No optional
// chaining. No em dash.

import { useState } from 'react';
import { buildPrintDocument } from '../../../monster/monsterStatBlock';

var DEFAULT_MODE = '5e';

function useMonsterStudioPreview() {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState(DEFAULT_MODE);

  // viStudioPreview: always (re)open at Standard 5E.
  function open() {
    setMode(DEFAULT_MODE);
    setIsOpen(true);
  }

  function close() {
    setIsOpen(false);
  }

  // viStudioPreviewSet.
  function setPreviewMode(next) {
    setMode(next);
  }

  // viStudioPreviewPrint: open a new window, write the printable document, print.
  // Returns false if pop-ups are blocked (the legacy alerted; the caller can choose
  // how to surface that). model is the live editor model, passed in at call time.
  function print(model) {
    if (!model) { return false; }
    if (typeof window === 'undefined' || !window.open) { return false; }
    var w = window.open('', '_blank');
    if (!w) { return false; }
    w.document.write(buildPrintDocument(model));
    w.document.close();
    w.focus();
    setTimeout(function() { try { w.print(); } catch (e) {} }, 300);
    return true;
  }

  return {
    isOpen: isOpen,
    mode: mode,
    open: open,
    close: close,
    setMode: setPreviewMode,
    print: print
  };
}

export default useMonsterStudioPreview;
